import clsx from 'clsx';
import { NavLink, useLocation, matchPath } from 'react-router-dom';

import { navigation } from '@/config';

import { Trail } from '../Animations';

export type NavigationProps = {
  className?: string;
  onClick?: () => void;
  enableTrail?: boolean;
};

export const Navigation = ({ className = '', enableTrail = false, onClick }: NavigationProps) => {
  const { pathname } = useLocation();
  const navigations = () =>
    navigation
      .filter((item) => !matchPath(pathname, item.to))
      .map((item, index) => (
        <NavLink
          end={index === 0}
          key={item.name}
          to={item.to}
          className={clsx(
            'transition duration-500 ease-in-out hover:text-primary transform hover:-translate-y-1 hover:scale-110',
            'group flex items-center px-2 py-2 font-medium font-serif'
          )}
          activeClassName="hidden"
          onClick={() => {
            onClick && onClick();
          }}
        >
          {/* <item.icon
            className={clsx(
              'text-gray-400 group-hover:text-gray-300',
              'mr-4 flex-shrink-0 h-6 w-6'
            )}
            aria-hidden="true"
          /> */}
          {item.name}
        </NavLink>
      ));

  return (
    <nav className={className}>
      {enableTrail ? <Trail trailProps={{ delay: 300 }}>{navigations()}</Trail> : navigations()}
    </nav>
  );
};
